module.exports = __webpack_public_path__ + "static/11.4_ancient_greece-c934cd9603be7167b779c6801771428a.pdf";